// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EI-z","modalContent":"FI-z","header":"GI-z","close":"HI-z"};